/**
 * Generato automaticamente.
 * framework-cmp-domande
 */

export type EnumTipoDomandaRequestModalitaRiepilogo =
  (typeof EnumTipoDomandaRequestModalitaRiepilogo)[keyof typeof EnumTipoDomandaRequestModalitaRiepilogo];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumTipoDomandaRequestModalitaRiepilogo = {
  STANDARD: 'STANDARD',
  ESTESO: 'ESTESO',
} as const;
